import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { MemberEvaluationService } from '../../../../app/members/member-evaluation.service';
import { EvaluationForm } from './models/evaluationForm';
import { MembersComponent } from 'src/app/members/members.component';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.scss'],
  standalone: false
})
export class EvaluationComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  evaluation: EvaluationForm;
  isLoadingOrSaving: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: MemberEvaluationService
  ) {}
  ngOnInit(): void {
    let secureLinkId = this.route.snapshot?.params['secureLinkId'];
    this.service.getEvaluationBySecureLinkId(secureLinkId);
    this.subs.push(
      this.service.evaluation.subscribe((result) => {
        if (result) {
          this.evaluation = result;
          if (this.evaluation.form.isPrivate && this.route.parent.component == MembersComponent) {
            location.href = `/portal/forms/evaluation/${secureLinkId}`;
            return;
          }
          this.service.setEvaluationForm();
          this.service.setIsLoadingOrSaving(false);
        }
      }),
      this.service.isLoadingOrSaving.subscribe((result) => {
        this.isLoadingOrSaving = result;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
  }
}
